import EnterpiseTeam from './EnterpiseTeam.component';

export default EnterpiseTeam;
